import React from 'react';
import ReactDOM from 'react-dom';
import utility from './utilities';
import qAppViz from './components/qAppViz';
import qDocSelections from './components/qDocSelections';
import qDocSelectionsToolbar from './components/qDocSelectionsToolbar';
import qDocSearch from './components/qDocSearch';
import qDocSimpleTable from './components/qDocSimpleTable';
import qDocMultiFieldSearch from './components/qDocMultiFieldSearch';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { palette, typography } from 'utils/Theme';
import { qlikClient } from 'constants/environmental';
import qAppBookmark from './components/qAppBookmarks';
import config from 'coeus.config';
import { lightTheme } from 'lib/FormBuilder/themes';

const theme = createTheme({
    ...lightTheme,
    ...{
        palette,
        ...typography,
    },
});

const SAAS = config.saas_client === qlikClient.SAAS;

//Containers
/**
 *
 *  Different types of components that can be loaded by this framework
 *
 **/
const components = {
    qAppViz,
    qDocSelections,
    QdtViz: qAppViz,
    QdtSelectionToolbar: qDocSelections,
    qDocSelectionsToolbar,
    qAppBookmark,

    //ABACUS ONLY
    qDocSearch,
    qDocSimpleTable,
    qDocMultiFieldSearch,

    // QdtFilter, QdtTable,  QdtSelectionToolbar, QdtKpi, QdtButton, QdtPicasso, QdtSearch, QdtCurrentSelections, QdtMapBox, QdtSequencer,
    // , qSelections, qBookmark
};

const SaaSComponents = {
    qAppViz,
    QdtViz: qAppViz,
    qDocSelectionsToolbar,
    qAppBookmark,
};

/**
 *
 * Main QVRF Class that will render each of the different component objects.
 *
 */
const Index = class {
    /**
     * Remove a mounted Qvrf component from the DOM and clean up its event handlers and state.
     * @param element = The React Qvrf component
     * @returns {boolean}
     */
    static unmountQvrfComponent = (element) =>
        ReactDOM.unmountComponentAtNode(element);

    static globals = utility.GLOBAL;

    constructor(
        config = {},
        connections = {
            vizApi: true,
            engineApi: true,
            useUniqueSessionID: null,
        },
        socket = null,
        pageId = null,
        addVisualisation = null
    ) {
        // if(connections.useUniqueSessionID){ qConfig.identity = connections.useUniqueSessionID; }
        // else if(qConfig.code){ qConfig.identity = null }
        // else{ qConfig.identity = utility.UID(16)}
        this.pageId = pageId;
        this.addVisualisation = addVisualisation;
        if (config) {
            this.qAppPromise = connections.vizApi ? socket.qAppPromise : null;
            this.qDocPromise = this.getDocPromise(
                connections.engineApi,
                socket
            );
        }
    }

    async getDocPromise(engineApi, socket) {
        if (!engineApi) return null;
        if (SAAS) return socket.qDocPromise;
        return await socket.getDoc();
    }

    render = async (type, props, element) =>
        new Promise((resolve, reject) => {
            try {
                const { qAppPromise, qDocPromise } = this;

                const qComponents = SAAS ? SaaSComponents : components;
                const Component = qComponents[type];

                ReactDOM.render(
                    <ThemeProvider theme={theme}>
                        <Component
                            {...props}
                            qAppPromise={qAppPromise}
                            qDocPromise={qDocPromise}
                            forwardRef={(node) => resolve(node)}
                            pageId={this.pageId}
                            addVisualisation={this.addVisualisation}
                        />
                    </ThemeProvider>,
                    element
                );
                //   console.info(version);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
};

export default Index;
